import { defineStore } from 'pinia'

import PostsRepository from '@/app/repositories/posts-repository'
import type { Post } from '@/common/models/data/dashboard/posts/post'

const useSearchStore = defineStore('search', {
    state: () => ({
        results: [] as Array<Post>,
        searching: false,
        query: ''
    }),
    actions: {
        async search (): Promise<void> {
            this.searching = true
            this.results = await PostsRepository.search(this.query)
            this.searching = false
        }
    }
})

export {
    useSearchStore
}
